export type TimelineItemProps = {
  id: string | number;
  time: string;
  message: string;
  status: 'success' | 'error';
  isAuditable?: boolean;
  isLink?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  onClick?: () => void;
};

export const timelineDataClient: TimelineItemProps[] = [
  {
    id: crypto.randomUUID(),
    time: '14:32',
    message: 'Login realizado',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:33',
    message: 'Visualizou a lista de OS',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:34',
    message: 'Abriu OS #2847',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:35',
    message: 'Tentou aprovar resultado, valor fora do padrão',
    status: 'error',
  },
  {
    id: crypto.randomUUID(),
    time: '14:40',
    message: 'Abriu OS #2848',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:41',
    message: 'Aprovou resultado',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:42',
    message: 'Visualizou lista de OS',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:43',
    message: 'Abriu OS #2849',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:44',
    message: 'Recusou resultado',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:45',
    message: 'Logout',
    status: 'success',
  },
];

export const timelineDataAdmUserDelegatedAccess: TimelineItemProps[] = [
  {
    id: crypto.randomUUID(),
    time: '14:32',
    message: 'Acesso delegado iniciado',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:33',
    message: 'Acessou conta do cliente',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:34',
    message: 'Abriu OS #2847',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:35',
    message: 'Tentou aprovar resultado, erro no sistema',
    status: 'error',
  },
  {
    id: crypto.randomUUID(),
    time: '14:40',
    message: 'Abriu OS #2848',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:41',
    message: 'Aprovou resultado',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:42',
    message: 'Visualizou lista de OS',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:43',
    message: 'Abriu OS #2849',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:44',
    message: 'Recusou resultado',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:45',
    message: 'Logout',
    status: 'success',
  },
];

export const timelineDataSectionsAdmUser: TimelineItemProps[] = [
  {
    id: crypto.randomUUID(),
    time: '14:32',
    message: 'Login realizado',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:33',
    message: 'Utilizou a barra de pesquisa',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:34',
    message: 'Resultado não encontrado',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:35',
    message: 'Utilizou o filtro',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:36',
    message: 'Abriu cliente Maria Josefina',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:37',
    message: 'Tentou iniciar sessão delegada',
    status: 'error',
  },
  {
    id: crypto.randomUUID(),
    time: '14:40',
    message: 'Acessou detalhamento da sessão da cliente',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:41',
    message: 'Acessou detalhamento da sessão da cliente',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:45',
    message: 'Iniciou accesso delegado (Nome do cliente)',
    status: 'success',
    isLink: true,
  },
  {
    id: crypto.randomUUID(),
    time: '14:46',
    message: 'Encerrou o acesso delegado',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:47',
    message: 'Utilizou a barra de pesquisa',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:48',
    message: 'Abriu cliente Fernanda Matos',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:49',
    message: 'Utilizou o filtro',
    status: 'success',
  },
  {
    id: crypto.randomUUID(),
    time: '14:50',
    message: 'Iniciou accesso delegado (Nome do cliente)',
    status: 'success',
    isLink: true,
  },
];
